/**
 * Подпись таймера хода в промо-матче против ИИ (см. utils/phase/turnTimeLimits).
 *
 * Стандартный ход длится не дольше пары минут, и кнопка завершения хода
 * показывает остаток секундами («38 сек»). Персональное время агента — до
 * 10 минут, и «587 сек» не читается: такой остаток показываем минутами
 * («9:47»).
 */

/**
 * Остаток хода в виде «м:сс»: 587 → «9:47», 5 → «0:05». Отрицательный и
 * нечисловой остаток — «0:00»
 */
export const formatTurnTimeLeftMinutes = (seconds) => {
  const safeSeconds = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0;
  const minutes = Math.floor(safeSeconds / 60);
  const restSeconds = safeSeconds % 60;
  return `${minutes}:${String(restSeconds).padStart(2, '0')}`;
};
